// Routes whose URL carries a bearer token (the unsubscribe link's ?token=).
// Analytics vendors attach the full page URL to whatever they send --
// Mixpanel's $current_url on every event, including its automatic $opt_in
// and $identify events; gtag's page location on its pings -- so analytics
// must not start or send anything while one of these pages is open.
//
// React Router matches paths case-insensitively and ignores a trailing slash,
// so this does too: /Email-Preferences/ is the same page.
const TOKEN_BEARING_PATHS = new Set(["/email-preferences"]);

export function isTokenBearingPath(pathname: string): boolean {
  const normalized = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  return TOKEN_BEARING_PATHS.has(normalized);
}

export function isOnTokenBearingPage(): boolean {
  return typeof window !== "undefined" && isTokenBearingPath(window.location.pathname);
}
